module.exports = __webpack_public_path__ + "img/pay-success@2x.95a79936.png";